
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/style.css';
import '@fortawesome/fontawesome-free/css/all.min.css';


const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
      <App/>
  </React.StrictMode>
);
